import { render, staticRenderFns } from "./QuickTipsSubmissionHistory.vue?vue&type=template&id=4fda7759&"
import script from "./QuickTipsSubmissionHistory.vue?vue&type=script&lang=js&"
export * from "./QuickTipsSubmissionHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports